import styled from 'styled-components';
import { Button as AntButton } from 'antd';
import { Severity } from '@app/types/ui';
// import { defineColorBySeverity } from '@app/utils/utils';

interface BtnProps {
  $severity?: Severity;
  $noStyle?: boolean;
}

export const Button = styled(AntButton)<BtnProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
`;
